import { DestroyRef, inject } from '@angular/core';
import { MethodError } from '@lentau/core/api/application';
import { lazyService } from '@lentau/ui-kit/core/helpers/lazy-service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CartErrorAnalyticService } from './cart-error-analytic.service';

const loadErrCartService = () => import('./cart-error-analytic.service').then((m) => m.CartErrorAnalyticService);

export const sendCartErrorAnalytic = (err: MethodError, name: string, isOrderUpdating: boolean) => {
  const ref = inject(DestroyRef);
  const cartErrorService = lazyService<CartErrorAnalyticService>(loadErrCartService).pipe(takeUntilDestroyed(ref));

  cartErrorService.subscribe((lazyLoadedService: CartErrorAnalyticService) =>
    lazyLoadedService.sendErrorAnalytic(err, name, isOrderUpdating)
  );
};
